// El texto de un post lo escribe cualquiera de la comunidad y se pinta con
// v-html para que anchorme deje los links clicables. anchorme NO escapa: la
// entrada vuelve tal cual, asi que `<img src=x onerror=...>` en un post se
// ejecutaba en el navegador de todos los que lo leian. Con el token de sesion
// en localStorage, eso es robo de sesion directo.
//
// Escapamos antes de linkificar: anchorme sigue encontrando las URLs y el HTML
// del atacante llega al DOM como texto.
//
// ponytail: mismo juego de caracteres que django.utils.html.escape, sin DOM ni
// dependencia nueva (asi corre tambien en node, y el check de al lado puede
// probarlo). Si algun dia hay que permitir markup real del usuario (negritas),
// recien ahi entra DOMPurify.
const REEMPLAZOS = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
};

export function escapeHtml(value) {
  if (value === null || value === undefined) return "";
  return String(value).replace(/[&<>"']/g, (c) => REEMPLAZOS[c]);
}

export default escapeHtml;
